import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SessionGuard } from '../shared/guards/session.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TestComponent } from './components/test/test.component';
import { PagesComponent } from './pages.component';
import { PageTabPanelComponent} from './components/page-tab-panel/page-tab-panel.component';
import { GraphicGuard } from '../shared/guards/graphic.guard';
// import { PersonalizationComponent } from './components/personalization/personalization.component';
import { MiPerfilComponent } from './components/mi-perfil/mi-perfil.component';
import { CompanySettingsListComponent } from './components/core/companySettings/company-settings-list/company-settings-list.component';
import { CompanySettingsComponent } from './components/core/companySettings/company-settings/company-settings.component';
import { ApplicationListComponent } from './components/microapplication/application-list/application-list.component';
import { MicroapplicationSettingsComponent } from './components/microapplication/microapplication-settings/microapplication-settings.component';
 import { RememberUserComponent } from './components/remember-user/remember-user.component';
import { WidgetConfigComponent } from './components/components/widget-config/widget-config.component';
import { WidgetVisualizerComponent } from './components/components/widget-visualizer/widget-visualizer.component';
import { widgetpreviewcomponent } from './components/components/widget-preview/widget-preview';


// import { LoginComponent } from './components/login/login.component';


const pagesRoutes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate:[SessionGuard],
    children: [
      // { path: 'login', component: DashboardComponent },
      // { path: 'remember', component: LoginComponent },
      { path: 'test', component: TestComponent },
      { path: 'remember', component: RememberUserComponent },
      { path: 'dashboard',canActivate:[GraphicGuard], component: DashboardComponent },
   
      { path: 'pageTabPanel',canActivate:[GraphicGuard], component: PageTabPanelComponent },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      // { path: 'personalizacion', component: PersonalizationComponent },
      { path: 'miPerfil', component: MiPerfilComponent },
      { path: 'CompanySettingsList', component: CompanySettingsListComponent },
      { path: 'companysettings/:id', component: CompanySettingsComponent },
      {path: 'companysettings',component: CompanySettingsComponent},
      { path: 'microapplication-list',component: ApplicationListComponent},
      {path: 'microapplication-settings',component: MicroapplicationSettingsComponent },
      {path: 'widgetconfigcomponent',component: WidgetConfigComponent },
      {path: 'widgetvisualizercomponent',component: WidgetVisualizerComponent },
      {path: 'widgetpreviewcomponent',component: widgetpreviewcomponent },
      
    ],
  }
  ,
// { path: `opheliaviewer`, component: OpheliaViewerComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(pagesRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class PagesRoutes {}
